import "../chunk-MQXBDTVK.js";

// src/connectors/walletConnect.ts
import { WalletConnectConnector } from "@wagmi/connectors/walletConnect";
export {
  WalletConnectConnector
};
